import React, {FC} from 'react';
import styled from 'styled-components';

import {PaletteColorsEnum} from '../../styles/paletteModel';
import {DropdownItem, DropdownItemProps} from './dropdownItem';
import {DropdownItemContent} from './dropdownItemContent';

/*
 * Props.
 */

interface SimpleDropdownItemWithColorProps extends DropdownItemProps {
  color?: PaletteColorsEnum;
}

/*
 * Style.
 */

const StyledDropdownItemContent = styled(DropdownItemContent)<{
  $color?: PaletteColorsEnum;
}>`
  color: ${(p) => p.$color && p.theme.palette[p.$color].shade40};
`;

/*
 * Component.
 */

export const SimpleDropdownItemWithColor: FC<SimpleDropdownItemWithColorProps> = ({color, ...props}) => (
  <DropdownItem {...props}>
    <StyledDropdownItemContent isChecked={props.isChecked} $color={color}>
      {props.children}
    </StyledDropdownItemContent>
  </DropdownItem>
);
